import React, {
  Component,
  createRef,
} from 'react';
import {TranscribingText} from 'app/components/DeviceDetails/TranscriberDevice/Text/TranscribingText';
import {TranscribingLP} from 'app/components/DeviceDetails/TranscriberDevice/Model/TranscribingLP';
import {isNil} from 'app/util/isNil';
import {parseLocationSearchParamsToJSON} from 'app/util/parseLocationSearchParamsToJSON';
import {publicTranscribeApi} from 'app/api/CirrusPublicTranscribeApi';
import {ApiResponseNumeralStatus} from 'app/data/Status';

function TranscriptionStoppedScreen() {
  return (
    <div className="transcription-stopped-screen">
      <span className="transcription-stopped-screen__text">
        This transcription session is not active.
      </span>

      <div className="transcription-stopped-screen__logo-container">
        <img
          className="transcription-stopped-screen__livescrypt-logo"
          src="/assets/img/public-transcribe/livescrypt-logo.png"
          alt="LiveScrypt"
          width={1314}
          height={192}
        />

        <img
          className="transcription-stopped-screen__epiphan-video-logo"
          src="/assets/img/public-transcribe/epiphan-video-logo.png"
          alt="Epiphan Video"
          width={305}
          height={47}
        />
      </div>
    </div>
  );
}

type Props = Record<string, unknown>;

type State = {
  transcript: any[];
  paused: boolean;
  stopped: boolean;
};

// to reworkd and get rid of ctor
export class PublicTranscribeRoot extends Component<Props, State> {
  public scrolledToBottom = true;
  public scrollContainerRef = createRef<HTMLDivElement>();
  public containerEndRef = createRef<HTMLDivElement>();

  // add types
  public transcribedIds = {};
  public transcript: any[] = [];
  public id: any;
  public lp: any;

  constructor(props) {
    super(props);

    // rework
    const parsed = parseLocationSearchParamsToJSON(window.location.search);
    this.id = parsed?.id;

    this.state = {
      transcript: [],
      paused: false,
      stopped: true,
    };

    this.lp = new TranscribingLP({
      call: ({version}, {getAbort}) => {
        if (version === 0) {
          this.transcript = [];
          this.transcribedIds = {};
          this.scrolledToBottom = true;

          this.setState({
            transcript: [],
          });
        }

        return publicTranscribeApi.public().transcribing(parsed?.id).changes({version}).get(undefined, {getAbort});
      },
      onUpdate: response => {
        const stopped = response.status === ApiResponseNumeralStatus.NoContent;
        const paused = stopped ? false : !isNil(response.data.stop_time);

        let transcript: any[] = [];
        let partialTranscript = null;

        if (stopped) {
          this.transcript = [];
          this.transcribedIds = {};
          this.scrolledToBottom = true;
        } else {
          response.data.transcript.forEach(item => {
            if (item.partial) {
              partialTranscript = item;
            } else {
              const {id} = item;

              if (this.transcribedIds[id] !== true) {
                this.transcribedIds[id] = true;
                this.transcript.push(item);
              }
            }
          });

          if (partialTranscript === null) {
            transcript = this.transcript;
          } else {
            transcript = [...this.transcript, partialTranscript];
          }
        }

        this.setState({
          transcript,
          paused,
          stopped,
        });
      },
    });
  }

  componentDidMount() {
    if (!isNil(this.id)) {
      this.lp.start();
    }
  }

  getSnapshotBeforeUpdate() {
    const element = this.scrollContainerRef.current;

    if (element) {
      // allow 50px inaccuracy by adding 50
      this.scrolledToBottom = element.scrollHeight - element.clientHeight <= element.scrollTop + 50;
    }

    return null;
  }

  componentDidUpdate() {
    if (this.scrolledToBottom === true) {
      setTimeout(() => {
        if (!this.containerEndRef.current) {
          return;
        }

        this.containerEndRef.current.scrollIntoView({behavior: 'smooth'});
        // element.scrollTop = element.scrollHeight - element.clientHeight
      });
    }
  }

  render() {
    const {
      transcript,
      paused,
      stopped,
    } = this.state;

    return (
      <div className="public-transcription-page">
        {stopped ? (
          <TranscriptionStoppedScreen/>
        ) : (
          <div
            ref={this.scrollContainerRef}
            className="public-transcription-page__transcribing-text-container"
          >
            <TranscribingText
              className="public-transcription-page__transcribing-text"
              placeholder=""
              transcript={transcript}
              itemsCount={0}
              paused={paused}
              // rework
              disabled={false}
            />

            <div ref={this.containerEndRef}/>
          </div>
        )}
      </div>
    );
  }
}
